import initDeleteMilestoneModal from './delete_milestone_modal_init';
import initPromoteMilestoneModal from './promote_milestone_modal_init';

export default () => {
  initDeleteMilestoneModal();
  initPromoteMilestoneModal();
};



// WEBPACK FOOTER //
// ./pages/milestones/shared/index.js